import { cva, type VariantProps } from 'class-variance-authority'
import type * as React from 'react'
import { Ring } from '@/components/loading-ui/ring'
import { cn } from '@/lib/utils'

const spinnerVariants = cva('text-muted-foreground', {
  defaultVariants: {
    size: 'md',
  },
  variants: {
    size: {
      lg: 'h-8 w-8',
      md: 'h-6 w-6',
      sm: 'h-4 w-4',
    },
  },
})

type SpinnerVariantSize = NonNullable<VariantProps<typeof spinnerVariants>['size']>

interface SpinnerProps extends Omit<React.SVGAttributes<SVGSVGElement>, 'width' | 'height'> {
  label?: string
  size?: SpinnerVariantSize | number
}

function Spinner({ className, label, size = 'md', ...props }: SpinnerProps) {
  const isNumericSize = typeof size === 'number'
  const variantSize = isNumericSize ? null : size
  const numericSizeProps = isNumericSize ? { height: size, width: size } : {}

  return (
    <Ring
      aria-hidden={label ? undefined : true}
      aria-label={label}
      className={cn(spinnerVariants({ size: variantSize }), className)}
      data-slot="spinner"
      role={label ? 'status' : undefined}
      {...numericSizeProps}
      {...props}
    />
  )
}

export { Spinner }
